import React, { FC } from "react";
import { styled } from "@mui/material/styles";
import MaterialTableBody, { TableBodyProps } from "@mui/material/TableBody";

import { COLOR_ATHENS_GRAY, COLOR_WHITE } from "../../constants/styles";

const StyledTableBody = styled(MaterialTableBody)`
  .MuiTableRow-root {
    max-height: 44px;
    background-color: ${COLOR_WHITE};

    &:nth-of-type(odd) {
      background-color: ${COLOR_ATHENS_GRAY};
    }
  }
`;

export const TableBody: FC<TableBodyProps> = React.forwardRef((props, ref) => <StyledTableBody {...props} ref={ref} />);
